export enum ErrorPageStatus {
  NotFound404 = 0,
  RevokeAccess403 = 1,
  Error500 = 2,
  Error401 = 3,
  Generic404 = 4,
}
